var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneScheildIcon = function SvgPhoneScheildIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h34v34H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D2329",
    d: "M10.413 12.57a1.98 1.98 0 0 1 .489-2.125l.914-.871a1.02 1.02 0 0 1 1.445 0l1.615 1.678a1.02 1.02 0 0 1 .212 1.127l-.807 1.89a6.8 6.8 0 0 0 4.25 4.25l1.87-.807a1 1 0 0 1 1.126.213l1.679 1.679a1.02 1.02 0 0 1 0 1.445l-.914.913a1.98 1.98 0 0 1-2.125.49 15.7 15.7 0 0 1-9.754-9.882m7.013 20.102a24.69 24.69 0 0 0 14.45-22.61 24.6 24.6 0 0 0-.255-3.506V6.11l-.362-.255a23.545 23.545 0 0 0-28.475 0l-.36.276v.425a26.5 26.5 0 0 0-.298 3.506 24.67 24.67 0 0 0 14.428 22.61l.447.277zM17 3.2a21.4 21.4 0 0 1 12.558 4.058q.175 1.398.192 2.805A22.55 22.55 0 0 1 17 30.526 22.67 22.67 0 0 1 4.378 7.45a21.25 21.25 0 0 1 12.623-4.25"
  })));
};
export default SvgPhoneScheildIcon;